import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ErrorMessage } from './styles';

const ErrorMessages = ({ titleError = '', descriptionError = '', internalCodeError = '' }) => {
  const { t } = useTranslation();
  return (
    <>
      {titleError && (
        <ErrorMessage data-publi='descriptionStep-title-error' typeError={titleError}>
          {t(`professionalPubli.description.title.message.${titleError}`)}
        </ErrorMessage>
      )}
      {descriptionError && (
        <ErrorMessage data-publi='descriptionStep-description-error' typeError={descriptionError}>
          {t(`professionalPubli.description.textDescription.message.${descriptionError}`)}
        </ErrorMessage>
      )}

      {internalCodeError && (
        <ErrorMessage
          data-publi='descriptionStep-internalCode-error'
          typeError={internalCodeError}
          internalCodeError={true}
        >
          {t(`professionalPubli.description.code.message.${internalCodeError}`)}
        </ErrorMessage>
      )}
    </>
  );
};

ErrorMessages.propTypes = {
  titleError: PropTypes.string,
  descriptionError: PropTypes.string,
  internalCodeError: PropTypes.string
};

export default ErrorMessages;
